/**
 * Composant Modal utilisant l'approche legacy avec checkbox ou ancre
 * 
 * @param {Object} props - Les props du composant
 * @param {ReactNode} props.children - Contenu du modal
 * @param {string} props.id - ID unique pour le modal
 * @param {string} props.className - Classes additionnelles pour le modal-box
 * @param {boolean} props.useCheckbox - Utiliser un checkbox au lieu d'une ancre (par défaut: true)
 * @returns {JSX.Element} Le composant ModalLegacy
 */
const ModalLegacy = ({
  children,
  id,
  className = '',
  useCheckbox = true
}) => {
  if (useCheckbox) {
    return (
      <>
        <input type="checkbox" id={id} className="modal-toggle" />
        <div className="modal" role="dialog">
          <div className={`modal-box ${className}`}>
            {children}
          </div>
          <label className="modal-backdrop" htmlFor={id}>Fermer</label>
        </div>
      </>
    )
  }

  return (
    <div className="modal" id={id} role="dialog">
      <div className={`modal-box ${className}`}>
        {children}
      </div>
    </div>
  )
}

// ModalLegacy.propTypes = {
//   children: PropTypes.node.isRequired,
//   id: PropTypes.string.isRequired,
//   className: PropTypes.string,
//   useCheckbox: PropTypes.bool
// }

export default ModalLegacy